import { ITargetPeriod } from '../Client/ITarget'

export const periodMapper = (period: ITargetPeriod) => {
  switch (period) {
    case 'daily':
      return 'day'

    case 'weekly':
      return 'isoWeek'

    case 'monthly':
      return 'month'

    case 'yearly':
      return 'year'
  }
}
